const features = [
    {
        id: 1,
        title: 'Trade a Variety of Assets',
        desc: 'Trade a diverse selection of tokens with integrated liquidity from top decentralized exchanges like Uniswap, Sushiswap, PancakeSwap, Biswap, and more on Leverage Protocol',
        icon: '2.png'
    },
    {
        id: 2,
        title: 'Minimize Trading Fee',
        desc: 'Maximize your trades with optimal pricing, avoiding additional costs through minimal spread and zero price impact when entering or exiting positions.',
        icon: '3.png'
    },
    {
        id: 3,
        title: 'Interoperable',
        desc: 'Leverage protocol Perp DEX offers broader market access, asset diversity, and increased liquidity,providing traders with greater flexibility and opportunities to optimize their strategies.',
        icon: '4.png'
    },
    {
        id: 4,
        title: 'Seamless User Experience',
        desc: 'Leverage Protocol Perp DX prioritizes a seamless user experience, enabling traders to easily access advanced features while trading in a user-friendly environment.',
        icon: '5.png'
    },
];

export default features;